import styles from './style.module.scss';
import { forwardRef } from "react";

interface Props {
    value: string;
    label?: string;
    hasError?: boolean;
    maxLength?: number;
    className?: string;
    isRequired?: boolean;
    placeholder?: string;
    onChange: (val: string) => void;
};

const TextArea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
    const {
        value,
        label,
        onChange,
        hasError,
        className,
        maxLength,
        placeholder,
        isRequired,
    } = props;

    return (
        <div className={`${styles.wrapper} ${className || ''}`}>
            {label && <label htmlFor="text_area">{label} {isRequired && <b>*</b>}</label>}
            <textarea
                ref={ref}
                value={value}
                rows={10}
                name="text_area"
                maxLength={maxLength}
                placeholder={placeholder}
                data-has-error={hasError}
                onChange={e => onChange(e.target.value)}
            />
        </div>
    )
});

export default TextArea;
